import React, { useState } from 'react';
import { PlusIcon } from 'lucide-react';
import { useAppState } from '../../contexts/AppStateContext';
import { copy } from '../../data/copy';
import { pollKindLabels } from '../../data/labels';
import { PollKind } from '../../types/shared';
import { Button } from '../ui/Button';
import { Chip, Field } from '../ui/Form';
import { EmptyNote } from '../ui/Panel';
import { Sheet } from '../ui/Sheet';
export function PollsBoard() {
  const {
    db,
    family,
    viewer,
    isAdmin,
    vote,
    closePoll,
    createPoll,
    addPollOption
  } = useAppState();
  const polls = db.polls.filter(p => p.familyId === family.id);
  const [creating, setCreating] = useState(false);
  const [title, setTitle] = useState('');
  const [kind, setKind] = useState<PollKind>('film');
  const [options, setOptions] = useState('');
  const [newOpt, setNewOpt] = useState<Record<string, string>>({});
  return <div data-id="element-210" data-mp="3eis7ltxj6hbg">
      <div className="mb-3 flex items-center justify-between gap-3" data-id="element-211" data-mp="3ejbhcnd11zee">
        <p className="text-sm text-muted" data-id="element-212" data-mp="16g7eyqy6fbng">Film, družabna igra, skupni čas, termini igranja. Dogovorjeno se lahko doda v koledar.</p>
        <Button size="sm" onClick={() => setCreating(true)} data-id="element-213" data-mp="12fdpvu8zzqsz">
          <PlusIcon className="h-4 w-4" aria-hidden="true" data-id="element-214" data-mp="12gyjnhnhn5ps" /> Glasovanje
        </Button>
      </div>
      {polls.length === 0 ? <EmptyNote data-id="element-215" data-mp="1bese0n1ozpab">{copy.emptyPolls}</EmptyNote> : <ul className="grid gap-3 md:grid-cols-2" data-id="element-216" data-mp="1bdhdcw3jmxnf">
          {polls.map(p => {
        const total = p.options.reduce((s, o) => s + o.votes.length, 0);
        const leader = Math.max(0, ...p.options.map(o => o.votes.length));
        return <li key={p.id} className="flex flex-col rounded-3xl border-[1.5px] border-line bg-surface p-4" data-id="element-217" data-mp="xgawj72dr90u">
                <div className="flex items-start justify-between gap-2" data-id="element-218" data-mp="sn7xwkiqx9ds">
                  <span data-id="element-219" data-mp="4y6nwsu9lq6e">
                    <span className="block font-display text-lg font-semibold leading-tight" data-id="element-220" data-mp="4xdpcf5gm6zc">{p.title}</span>
                    <span className="text-xs text-muted" data-id="element-221" data-mp="3w3f4ozwgjmqs">
                      {pollKindLabels[p.kind]} · {total} glasov · {p.open ? 'odprto' : 'zaključeno'}
                    </span>
                  </span>
                </div>
                <ul className="mt-3 space-y-2" data-id="element-222" data-mp="29sg5mv3ihpwh">
                  {p.options.map(o => {
              const mine = o.votes.includes(viewer.id);
              const pct = total ? Math.round(o.votes.length / total * 100) : 0;
              return <li key={o.id} data-id="element-223" data-mp="1h5lpgadq9cot">
                        <button type="button" disabled={!p.open} onClick={() => vote(p.id, o.id)} aria-pressed={mine} className={`relative w-full overflow-hidden rounded-2xl border-[1.5px] px-3 py-2 text-left text-sm font-bold ${mine ? 'border-accent' : 'border-line'} ${!p.open && o.votes.length === leader && leader > 0 ? 'bg-done-soft' : ''}`} data-id="element-224" data-mp="1m23octmdmgt8">
                          <span className="absolute inset-y-0 left-0 bg-sun-soft" style={{
                    width: `${pct}%`
                  }} aria-hidden="true" data-id="element-225" data-mp="3gmnchdq2qc1c" />
                          <span className="relative flex justify-between" data-id="element-226" data-mp="3bnu9if8ey3ff">
                            <span data-id="element-227" data-mp="36vizgjjyl195">{o.label}</span>
                            <span className="tabular-nums" data-id="element-228" data-mp="36u7uwhiovpgz">{o.votes.length}</span>
                          </span>
                        </button>
                      </li>;
            })}
                </ul>
                {p.open && <form className="mt-2 flex gap-2" onSubmit={e => {
            e.preventDefault();
            const v = newOpt[p.id]?.trim();
            if (v) addPollOption(p.id, v);
            setNewOpt(n => ({
              ...n,
              [p.id]: ''
            }));
          }} data-id="element-229" data-mp="2sw1e6e5vg64j">
                    <input className="field h-9 text-sm" aria-label="Nov predlog" placeholder="Dodaj predlog" value={newOpt[p.id] ?? ''} onChange={e => setNewOpt(n => ({
              ...n,
              [p.id]: e.target.value
            }))} data-id="element-230" data-mp="i48fj7cyq5gt" />
                    <Button size="sm" variant="secondary" type="submit" data-id="element-231" data-mp="u7ax9i1vjoye">
                      Dodaj
                    </Button>
                  </form>}
                {p.open && (isAdmin || p.createdBy === viewer.id) && <Button size="sm" variant="ghost" className="mt-2 self-end" onClick={() => closePoll(p.id)} data-id="element-232" data-mp="kay8myl6s1ai">
                    Zaključi glasovanje
                  </Button>}
              </li>;
      })}
        </ul>}
      <Sheet open={creating} onClose={() => setCreating(false)} title="Novo glasovanje" footer={<Button className="w-full" disabled={!title.trim() || options.split('\n').filter(o => o.trim()).length < 2} onClick={() => {
      createPoll(title.trim(), kind, options.split('\n').map(o => o.trim()).filter(Boolean));
      setCreating(false);
      setTitle('');
      setOptions('');
    }} data-id="element-234" data-mp="1in83be08ffk">
            Začni glasovanje
          </Button>} data-id="element-233" data-mp="3spq188dekvsf">
        <div className="space-y-4" data-id="element-235" data-mp="3e283xv2673g1">
          <div className="flex flex-wrap gap-2" data-id="element-236" data-mp="3e3aug1vkz3vf">
            {(Object.keys(pollKindLabels) as PollKind[]).map(k => <Chip key={k} active={kind === k} onClick={() => setKind(k)} data-id="element-237" data-mp="3a2qxozex629t">
                {pollKindLabels[k]}
              </Chip>)}
          </div>
          <Field label="Vprašanje" data-id="element-238" data-mp="3j09jw74aumna">{id => <input id={id} className="field" value={title} onChange={e => setTitle(e.target.value)} placeholder="npr. Kam v nedeljo?" data-id="element-239" data-mp="3iz8ae72xm87o" />}</Field>
          <Field label="Možnosti (vsaka v svojo vrstico, vsaj 2)" data-id="element-240" data-mp="3sqm7y9bboxy6">
            {id => <textarea id={id} rows={4} className="field" value={options} onChange={e => setOptions(e.target.value)} data-id="element-241" data-mp="akznnfn3cbnf" />}
          </Field>
        </div>
      </Sheet>
    </div>;
}